import React,{useState,useEffect,useRef} from 'react';
import Axios from 'axios';
import EditProfilePic from './EditProfilePic';
import ProfilePic from './ProfilePic';
import RemoveProfilePic from './RemoveProfilePic';
import AlimLoader from './AlimLoader';

const EditProfilePicContainer=({webToken,userData})=>{
    const [currentProPic,setCurrentProPic]=useState(localStorage.getItem("alimProfilePic"));
    const [newProPic,setNewProPic]=useState(null);
    const [imgBlob,setImgBlob]=useState(null);
    const [showImage,setShowImage]=useState(true);
    const [isImageProcessing,setIsImageProcessing]=useState(false);

    const updloadProfilePic=()=>{
        setIsImageProcessing(true);
        Axios.post(`${alimAPIBaseURI}rpc/update_user_profile_pic`, {pro_pic:newProPic},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
            if(data.data==="Profile pic updated")
            {
                localStorage.removeItem("alimProfilePic");
                document.dispatchEvent(profilePicEvent);
                showAlert(`Profile picture updated!`);
                setCurrentProPic(newProPic);
                setNewProPic(null);
            }
        }).catch((error)=>{
            console.log(error);
            setNewProPic(null);
        }).finally(()=>{
            setIsImageProcessing(false);
        });
    }

    const updateProfilePic=()=>{
        setNewProPic(null);
        setCurrentProPic(null);
        setImgBlob(null);
        setShowImage(false);
    }

    const handleDragOver=(event)=>{
        event.preventDefault();
    }

    const handleDrop=(event)=>{
        event.preventDefault();
        const supportedExt=["png","jpeg","jpg"];
        const file=event.dataTransfer.files[0]
        const fileExt= file.name.match(/\.([^\.]+)$/)[1];
        if(file.size>51200)
        {
            showAlert("Please select a file with size 50KB or less.");
            setImgBlob(null);
            setNewProPic(null);
        }
        else if(!supportedExt.includes(fileExt))
        {
            showAlert("Please select a file with extensions: png, jpg or jpeg.");
            setImgBlob(null);
            setNewProPic(null);
        }
        else if(file.size<=51200)
        {
            const fr = new FileReader();
            fr.readAsArrayBuffer(file);
            fr.onload = function () {
                const blob = new Blob([fr.result]);
                setImgBlob(blob);
            };
        }
    }

    useEffect(()=>{
        if(!showImage)
        {
            setShowImage(true);
        }
    },[newProPic,currentProPic,showImage]);

    useEffect(()=>{
        if(imgBlob!==null)
        {
            let reader = new FileReader();
            reader.readAsDataURL(imgBlob);
            reader.onloadend = function () {
                let base64String = reader.result;
                setNewProPic(base64String);
                setShowImage(false);
            }
            console.log('trigger blob');
        }
    },[imgBlob]);

    return(
        <div className='flex flex-col gap-3 items-center relative w-full md:w-[365px]'>
            <div className='p-4'>

            </div>
            <div className='absolute z-10 bg-light-beige dark:bg-light-blue rounded-full'>
                {showImage&&<ProfilePic profilePic={newProPic!==null?newProPic:currentProPic} profileData={userData} webToken={webToken} customSize={"w-[85px] h-[85px]"}></ProfilePic>}
            </div>
            <div className='bg-light-beige dark:bg-deep-blue min-h-40 relative rounded-lg px-2 w-full border border-light-blue dark:border-white border-dashed flex flex-col justify-center gap-1' onDragOver={handleDragOver} onDrop={handleDrop}>
                <div className='flex justify-center mt-8 gap-1'>
                    <span className='relative overflow-hidden underline w-[114px] font-medium'>
                        Click to upload
                        {showImage&&<EditProfilePic webToken={webToken} userEmail={userData.user_email} profilePicStateFunc={setNewProPic} additionalStyles={"opacity-0 absolute bottom-0 left-0"}/>}
                    </span>
                    <span>
                     or drag and drop
                    </span>
                </div>
                <span className='text-center w-full text-sm'>Maximum file size 50KB.</span>
            </div>

            {
                isImageProcessing?
                    <div className='flex justify-center'>
                        <AlimLoader/>
                    </div>
                :
                    <div className='flex gap-3'>
                        <RemoveProfilePic alimWebToken={webToken} alimUserData={userData} profilePicFunc={updateProfilePic} imgProcessFunc={setIsImageProcessing}/>
                        <button className={`bg-deep-red rounded-md px-3 py-2 text-white h-full ${newProPic===null?"opacity-50":""}`} onClick={updloadProfilePic} disabled={newProPic===null?true:false}>
                            Update profile pic
                        </button>
                    </div>
            }
        </div> 
    );
}

export default EditProfilePicContainer;